module.exports = __webpack_public_path__ + "img/rd-ur3.2abfcd02.jpg";